import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import { RadioComponentSwitch } from '@openx/components-core/lib/RadioComponentSwitch/RadioComponentSwitch';
import type { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useDemographicGender } from '../../../../../../../../modules/audiences/AudienceForm/components/AudienceCriteria/hooks/useDemographicGender';
import type { FormSegment } from '../../../../../../../../modules/audiences/AudienceForm/types';

export type DemographicsGenderProps = {
  selectedGenderSegments: FormSegment[];
  isEdit: boolean;
  setSelectedGenderSegments: Dispatch<SetStateAction<FormSegment[]>>;
};

export const DemographicsGender = ({
  isEdit,
  selectedGenderSegments,
  setSelectedGenderSegments,
}: DemographicsGenderProps) => {
  const { t } = useTranslation();

  const { handleChange, initialSelectedOption, genderButtonOptions } = useDemographicGender({
    selectedGenderSegments,
    isEdit,
    setSelectedGenderSegments,
  });

  const selectedOption = selectedGenderSegments.length > 0 ? selectedGenderSegments[0].name : 'Any';

  return (
    <FormControl>
      <Typography
        variant="h3"
        component="p"
        sx={{
          textTransform: 'uppercase',
          pb: 1,
        }}
      >
        {t('Gender')}
      </Typography>
      {isEdit ? (
        <RadioComponentSwitch
          overrideXsValue={0}
          onSwitchChange={e => handleChange(e)}
          selectedOption={initialSelectedOption}
        >
          {genderButtonOptions.map(({ name }) => ({
            child: null,
            dataTest: `audience-demographics-gender-radio-${name}`,
            helperText: '',
            label: t(name),
          }))}
        </RadioComponentSwitch>
      ) : (
        <Typography>{selectedOption}</Typography>
      )}
    </FormControl>
  );
};
